/**
 * Layout - header
 */

export const header = ():void => {
  const bodyElement = document.querySelector('body') as unknown as HTMLElement
  const headerElement = document.querySelector('.js-header') as unknown as HTMLElement
  const summonElement = document.querySelector('.js-header-phoneSummon') as unknown as HTMLElement

  const checkForScroll = () => {
    const scolledFromTop = window.scrollY

    if (scolledFromTop > 0) {
      headerElement.classList.add('-boxShadow')
    }
    else {
      headerElement.classList.remove('-boxShadow')
    }
  }

  document.addEventListener('click', (e) => {
    const triggerElement = e.target as unknown as HTMLElement
    const menuElement = triggerElement.closest('.js-header-menuWrapper')

    if (!triggerElement.classList.contains('js-headerMenu') && !menuElement && summonElement !== triggerElement) {
      bodyElement.classList.remove('-menuPopupPhone')
    }
  })

  const hookMobileControls = () => {
    headerElement.addEventListener('swiped-right', function (e: any) {
      const startX: number = e.detail.xStart
      const endX: number = e.detail.xEnd

      if (startX - endX <= -50) {
        bodyElement.classList.remove('-menuPopupPhone')
      }
    })
  }

  hookMobileControls()

  summonElement.addEventListener('click', () => {
    bodyElement.classList.add('-menuPopupPhone')
  })

  window.addEventListener('scroll', () => {
    checkForScroll()
  })

  checkForScroll()
}
